// AUTO-GENERATED from .env files
// Prefix: CLIENT_
export const environment = {
    "serverApiUrl": "https://ceremabo-api-recette.cerema.dev/api",
    "orionUrl": "https://orion-recette.cerema.fr/auth/realms/CeremaApps",
    "clientId": "ceremabo_recette",
    "redirectUri": "https://ceremabo-recette.cerema.dev",
    "deconnexionUri": "https://ceremabo-recette.cerema.dev/login",
    "homePath": "/",
    "redirectPage": "/dashboard",
    "runtime": true
};
